import axios from 'axios';

export const getGroupsList = () => axios.get('/contract_specs/list/');
export const getContractSpecs = (groupId, groupName, lang) =>
  axios.get(`/contract_specs/${groupId}/`, { params: { group: groupName, lang } });
export const getCommentsList = () => axios.get(`/config/resource/PriceGroupCommentResource/resource/`);
